import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSaveVarientSlice = createApi(`GetSaveVarientSlice`,"GET");

const GetSaveVarientSlice = createSlice({
  name: 'GetSaveVarientSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSaveVarientSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSaveVarientSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSaveVarientSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetSaveVarientSlice.reducer;